(function () {
  'use strict';

  var isLoading = false;
  var sectionId = null;

  function setup() {
    var grid = document.getElementById('product-grid');
    if (grid && grid.dataset.id) sectionId = grid.dataset.id;

    var pagination = document.querySelector('#ProductGridContainer .pagination-wrapper');
    if (pagination) pagination.hidden = true;
  }

  function onScroll() {
    if (isLoading) return;
    var sentinel = document.getElementById('infinite-scroll-sentinel');
    if (!sentinel) return;

    var rect = sentinel.getBoundingClientRect();
    if (rect.top <= window.innerHeight + 600) {
      loadMore(sentinel.dataset.url);
    }
  }

  function loadMore(url) {
    if (!url || isLoading) return;
    isLoading = true;

    var loader = document.getElementById('infinite-scroll-loader');
    if (loader) loader.removeAttribute('hidden');

    var fetchUrl = sectionId ? url + '&section_id=' + sectionId : url;

    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid .grid__item');
        var grid = document.getElementById('product-grid');

        if (grid && items.length) {
          items.forEach(function (item) { grid.appendChild(item); });
        }

        var sentinel = document.getElementById('infinite-scroll-sentinel');
        var newSentinel = doc.getElementById('infinite-scroll-sentinel');
        if (sentinel) {
          if (newSentinel) {
            sentinel.dataset.url = newSentinel.dataset.url;
          } else {
            sentinel.remove();
          }
        }
      })
      .catch(function (e) { console.error('[InfiniteScroll]', e); })
      .finally(function () {
        isLoading = false;
        var loader = document.getElementById('infinite-scroll-loader');
        if (loader) loader.setAttribute('hidden', '');
      });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Re-init after facets.js replaces the grid on filter/sort
  var container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(function () {
      isLoading = false;
      setup();
    }).observe(container, { childList: true });
  }

  setup();
  // Check immediately on load in case products are already near bottom
  onScroll();
})();
